import React from 'react';

const PageLoader = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
            <div className="flex flex-col items-center gap-4">
                <div className="relative">
                    {/* Fast spinning loader */}
                    <div className="w-12 h-12 border-4 border-blue-500/30 rounded-full"></div>
                    <div className="absolute top-0 left-0 w-12 h-12 border-4 border-transparent border-t-blue-500 rounded-full animate-spin" style={{ animationDuration: '0.6s' }}></div>
                </div>
                <p className="text-blue-200 text-sm font-medium animate-pulse">Loading...</p>
            </div>
        </div>
    );
};

export default PageLoader;
